import { isTextNode, isWidgetNode } from '@creative/nodes/helpers';
import { deserializePropertyValue } from '@creative/serialization';
import { isVariableSpan } from '../rich-text/text-nodes';
export function encodeFeedPath(path) {
    return path.replace(/\s/g, '%20');
}
export function decodeFeedPath(path) {
    return path.replace(/%20/g, ' ');
}
export function createFeed(id, path = '', type = 'text') {
    const feed = {
        id: id,
        path: encodeFeedPath(path !== null && path !== void 0 ? path : ''),
        step: {
            occurrence: 'loop',
            size: 1,
            start: 1
        },
        fallback: '',
        type: type
    };
    return feed;
}
export function createVariable(id, path = '') {
    return Object.assign(Object.assign({}, createFeed(id, path, 'text')), { type: 'text' });
}
export function isCustomFeedProperty(customProperty) {
    return customProperty.unit === 'feed';
}
export function isFeedValue(value) {
    if (typeof value !== 'object') {
        return false;
    }
    if ('id' in value && 'path' in value && 'step' in value) {
        return true;
    }
    return false;
}
export function isVersionedFeed(property) {
    if (isFeedValue(property.value)) {
        return true;
    }
    return false;
}
export function hasFeededContent(element) {
    var _a;
    if (element.feed) {
        return true;
    }
    if (isTextNode(element)) {
        const content = ((_a = element.__dirtyContent) === null || _a === void 0 ? void 0 : _a.spans) || element.content.spans;
        for (const span of content) {
            if (isVariableSpan(span)) {
                return true;
            }
        }
    }
    if (isWidgetNode(element)) {
        for (const property of element.customProperties) {
            try {
                if (isCustomFeedProperty(property)) {
                    const feed = deserializePropertyValue('feed', property.value);
                    if (feed === null || feed === void 0 ? void 0 : feed.id) {
                        return true;
                    }
                }
            }
            catch (e) {
                throw new Error(`Failed to parse widget property ${property.unit} - "${property.name}" value "${property.value}"`);
            }
        }
    }
    return false;
}
// extracts all feed ids from a given element. Text & widgets can contain multiple feeds.
export function getFeedIds(element) {
    var _a;
    if (element.feed) {
        return [element.feed.id];
    }
    const feedIds = new Set();
    if (isTextNode(element)) {
        const content = ((_a = element.__dirtyContent) === null || _a === void 0 ? void 0 : _a.spans) || element.content.spans;
        for (const span of content) {
            if (isVariableSpan(span) && span.style.variable) {
                feedIds.add(span.style.variable.id);
            }
        }
    }
    if (isWidgetNode(element)) {
        for (const property of element.customProperties) {
            try {
                if (isCustomFeedProperty(property)) {
                    const feed = deserializePropertyValue('feed', property.value);
                    if (feed === null || feed === void 0 ? void 0 : feed.id) {
                        feedIds.add(feed.id);
                    }
                }
            }
            catch (e) {
                throw new Error(`Failed to parse widget property ${property.unit} - "${property.name}" value "${property.value}"`);
            }
        }
    }
    return [...feedIds];
}
export function isFeedpathProperty(property) {
    return property.name.indexOf('feedPath') > -1;
}
